// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleVisitCard-module__font-s-10___gtsup {
  font-size: 10px !important;
}

.HuddleVisitCard-module__font-s-12___kpHFL {
  font-size: 12px !important;
}

.HuddleVisitCard-module__font-s-13___LvrDA {
  font-size: 13px !important;
}

.HuddleVisitCard-module__font-s-14___zJmru {
  font-size: 14px !important;
}

.HuddleVisitCard-module__font-s-15___Hk1Wl {
  font-size: 15px !important;
}

.HuddleVisitCard-module__font-s-16___Uu0hi {
  font-size: 16px !important;
}

.HuddleVisitCard-module__font-s-18___qH2Lv {
  font-size: 18px !important;
}

.HuddleVisitCard-module__font-s-20___YKGTc {
  font-size: 20px !important;
}

.HuddleVisitCard-module__font-s-22___YTvyy {
  font-size: 22px !important;
}

.HuddleVisitCard-module__font-s-28___y9nFW {
  font-size: 28px !important;
}

.HuddleVisitCard-module__font-w-400___gmRzx {
  font-weight: 400 !important;
}

.HuddleVisitCard-module__font-w-500___RMOpB {
  font-weight: 500 !important;
}

.HuddleVisitCard-module__font-w-600___KiRDZ {
  font-weight: 600 !important;
}

.HuddleVisitCard-module__font-w-700___EH0KR {
  font-weight: 700 !important;
}

.HuddleVisitCard-module__p-5___XGlmZ {
  padding: 5px !important;
}

.HuddleVisitCard-module__p-12___l3mUB {
  padding: 12px !important;
}

.HuddleVisitCard-module__p-16___qwFlh {
  padding: 16px !important;
}

.HuddleVisitCard-module__p-30___MllfN {
  padding: 30px !important;
}

.HuddleVisitCard-module__p-b-0___UkGYT {
  padding-bottom: 0 !important;
}

.HuddleVisitCard-module__p-b-5___uibvp {
  padding-bottom: 5px !important;
}

.HuddleVisitCard-module__p-b-10___V11tz {
  padding-bottom: 10px !important;
}

.HuddleVisitCard-module__p-b-12___oqZPo {
  padding-bottom: 12px !important;
}

.HuddleVisitCard-module__p-b-16___bIERf {
  padding-bottom: 16px !important;
}

.HuddleVisitCard-module__p-b-18___ez_KI {
  padding-bottom: 18px !important;
}

.HuddleVisitCard-module__p-b-20___XfswE {
  padding-bottom: 20px !important;
}

.HuddleVisitCard-module__p-b-25___jRPSg {
  padding-bottom: 25px !important;
}

.HuddleVisitCard-module__p-b-30___ozrds {
  padding-bottom: 30px !important;
}

.HuddleVisitCard-module__p-b-50___PG4Ql {
  padding-bottom: 50px !important;
}

.HuddleVisitCard-module__p-t-0___CcR8B {
  padding-top: 0 !important;
}

.HuddleVisitCard-module__p-t-12___M7a_f {
  padding-top: 12px !important;
}

.HuddleVisitCard-module__p-t-16___HKVAK {
  padding-top: 16px !important;
}

.HuddleVisitCard-module__p-t-18___wntr0 {
  padding-top: 18px !important;
}

.HuddleVisitCard-module__p-t-20___Wc954 {
  padding-top: 20px !important;
}

.HuddleVisitCard-module__p-t-30___Qg3Qy {
  padding-top: 30px !important;
}

.HuddleVisitCard-module__p-t-40___QvkR8 {
  padding-top: 40px !important;
}

.HuddleVisitCard-module__p-t-50___jV6Jg {
  padding-top: 50px !important;
}

.HuddleVisitCard-module__p-l-20___TxcYD {
  padding-left: 20px !important;
}

.HuddleVisitCard-module__p-l-30___qDaD0 {
  padding-left: 30px !important;
}

.HuddleVisitCard-module__p-l-40___sZHGA {
  padding-left: 40px !important;
}

.HuddleVisitCard-module__p-r-16___ytIyM {
  padding-right: 16px !important;
}

.HuddleVisitCard-module__p-r-20___nv8Hz {
  padding-right: 20px !important;
}

.HuddleVisitCard-module__p-r-30___pXiWo {
  padding-right: 30px !important;
}

.HuddleVisitCard-module__p-r-50___CAJPx {
  padding-right: 50px !important;
}

.HuddleVisitCard-module__p-r-60___krWXE {
  padding-right: 60px !important;
}

.HuddleVisitCard-module__m-b-1___uzABy {
  margin-bottom: 1px !important;
}

.HuddleVisitCard-module__m-b-2___fhJDe {
  margin-bottom: 2px !important;
}

.HuddleVisitCard-module__m-b-6___cWvm_ {
  margin-bottom: 6px !important;
}

.HuddleVisitCard-module__m-b-8___hctOj {
  margin-bottom: 8px !important;
}

.HuddleVisitCard-module__m-b-10___jNErZ {
  margin-bottom: 10px !important;
}

.HuddleVisitCard-module__m-b-14___ilnk7 {
  margin-bottom: 14px !important;
}

.HuddleVisitCard-module__m-b-16___XgbCV {
  margin-bottom: 16px !important;
}

.HuddleVisitCard-module__m-b-20___ffHxa {
  margin-bottom: 20px !important;
}

.HuddleVisitCard-module__m-b-22___UJ8p4 {
  margin-bottom: 22px !important;
}

.HuddleVisitCard-module__m-b-24___q2fR3 {
  margin-bottom: 24px !important;
}

.HuddleVisitCard-module__m-b-30___HsCOb {
  margin-bottom: 30px !important;
}

.HuddleVisitCard-module__m-b-32___vYirt {
  margin-bottom: 32px !important;
}

.HuddleVisitCard-module__m-b-40___WdnHs {
  margin-bottom: 40px !important;
}

.HuddleVisitCard-module__m-t-2___oSJRl {
  margin-top: 2px !important;
}

.HuddleVisitCard-module__m-t-3___Lfqxs {
  margin-top: 3px !important;
}

.HuddleVisitCard-module__m-t-4___wC78H {
  margin-top: 4px !important;
}

.HuddleVisitCard-module__m-t-5___PbxdR {
  margin-top: 5px !important;
}

.HuddleVisitCard-module__m-t-8___SKtjL {
  margin-top: 8px !important;
}

.HuddleVisitCard-module__m-t-10___P4CO3 {
  margin-top: 10px !important;
}

.HuddleVisitCard-module__m-t-15___cFPo3 {
  margin-top: 15px !important;
}

.HuddleVisitCard-module__m-t-16___pVZJq {
  margin-top: 16px !important;
}

.HuddleVisitCard-module__m-t-20___ydWwW {
  margin-top: 20px !important;
}

.HuddleVisitCard-module__m-t-22___ZDNNv {
  margin-top: 22px !important;
}

.HuddleVisitCard-module__m-t-30___ZFYB_ {
  margin-top: 30px !important;
}

.HuddleVisitCard-module__m-t-32___S7o3u {
  margin-top: 32px !important;
}

.HuddleVisitCard-module__m-l-auto___lIgGb {
  margin-left: auto !important;
}

.HuddleVisitCard-module__m-l-4___ABWaO {
  margin-left: 4px !important;
}

.HuddleVisitCard-module__m-l-5___jiDeE {
  margin-left: 5px !important;
}

.HuddleVisitCard-module__m-l-6___mXOlL {
  margin-left: 6px !important;
}

.HuddleVisitCard-module__m-l-8___X3Gh2 {
  margin-left: 8px !important;
}

.HuddleVisitCard-module__m-l-10___OG2aR {
  margin-left: 10px !important;
}

.HuddleVisitCard-module__m-l-16___jBqYw {
  margin-left: 16px !important;
}

.HuddleVisitCard-module__m-l-20___BQS4R {
  margin-left: 20px !important;
}

.HuddleVisitCard-module__m-l-24___Zyjjw {
  margin-left: 24px !important;
}

.HuddleVisitCard-module__m-l-30___cZsvS {
  margin-left: 30px !important;
}

.HuddleVisitCard-module__m-l-35___OpR6q {
  margin-left: 35px !important;
}

.HuddleVisitCard-module__m-l-40___Q2hJ2 {
  margin-left: 40px !important;
}

.HuddleVisitCard-module__m-r-8___hkI8g {
  margin-right: 8px !important;
}

.HuddleVisitCard-module__m-r-10___L3nAL {
  margin-right: 10px !important;
}

.HuddleVisitCard-module__m-r-16___j72dv {
  margin-right: 16px !important;
}

.HuddleVisitCard-module__m-r-20___MO4s2 {
  margin-right: 20px !important;
}

.HuddleVisitCard-module__m-r-24___wopSw {
  margin-right: 24px !important;
}

.HuddleVisitCard-module__m-r-30___zUu2f {
  margin-right: 30px !important;
}

.HuddleVisitCard-module__m-r-40___eLdkz {
  margin-right: 40px !important;
}

.HuddleVisitCard-module__border-r-3____fFy1 {
  border-radius: 3px !important;
}

.HuddleVisitCard-module__border-r-4___Noc7T {
  border-radius: 4px !important;
}

.HuddleVisitCard-module__border-r-6___moKU8 {
  border-radius: 6px !important;
}

.HuddleVisitCard-module__border-r-10___oQsCE {
  border-radius: 10px !important;
}

.HuddleVisitCard-module__border-r-12___BP00Z {
  border-radius: 12px !important;
}

.HuddleVisitCard-module__border-r-16___syWTW {
  border-radius: 16px !important;
}

.HuddleVisitCard-module__border-r-50___baR_W {
  border-radius: 50% !important;
}

.HuddleVisitCard-module__primary-border___YbSJr {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.HuddleVisitCard-module__primary-border-b___eT2Iz {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.HuddleVisitCard-module__primary-border-t___gQNLs {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.HuddleVisitCard-module__primary-border-l___t2jgr {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.HuddleVisitCard-module__primary-border-r___HaQEK {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.HuddleVisitCard-module__secondary-border___gQgeV {
  border: 1px solid #637768;
}

.HuddleVisitCard-module__secondary-border-b___MkhSQ {
  border-bottom: 1px solid #637768;
}

.HuddleVisitCard-module__secondary-border-t___dTgZK {
  border-top: 1px solid #637768;
}

.HuddleVisitCard-module__secondary-border-l___aiKLa {
  border-left: 1px solid #637768;
}

.HuddleVisitCard-module__secondary-border-r___ueEiT {
  border-right: 1px solid #637768;
}

.HuddleVisitCard-module__gap-0___USMpO {
  gap: 0 !important;
}

.HuddleVisitCard-module__gap-2___JjgxK {
  gap: 2px !important;
}

.HuddleVisitCard-module__gap-4___OaemZ {
  gap: 4px !important;
}

.HuddleVisitCard-module__gap-5___BTZ8K {
  gap: 5px !important;
}

.HuddleVisitCard-module__gap-6___l3Nub {
  gap: 6px !important;
}

.HuddleVisitCard-module__gap-8___hOcI2 {
  gap: 8px !important;
}

.HuddleVisitCard-module__gap-10___g18Pj {
  gap: 10px !important;
}

.HuddleVisitCard-module__gap-12___W6gfg {
  gap: 12px !important;
}

.HuddleVisitCard-module__gap-14___SG7LG {
  gap: 14px !important;
}

.HuddleVisitCard-module__gap-16___Lm22z {
  gap: 16px !important;
}

.HuddleVisitCard-module__gap-18___S9l2x {
  gap: 18px !important;
}

.HuddleVisitCard-module__gap-20___OYcL_ {
  gap: 20px !important;
}

.HuddleVisitCard-module__gap-24___m55BP {
  gap: 24px !important;
}

.HuddleVisitCard-module__gap-26___ERqTT {
  gap: 26px !important;
}

.HuddleVisitCard-module__gap-30___ElnfE {
  gap: 30px !important;
}

.HuddleVisitCard-module__gap-32___WbdZp {
  gap: 32px !important;
}

.HuddleVisitCard-module__gap-40___uj46c {
  gap: 40px !important;
}

.HuddleVisitCard-module__gap-50___cSbFX {
  gap: 50px !important;
}

.HuddleVisitCard-module__flex-1___edB6P {
  flex: 1;
}

.HuddleVisitCard-module__flex-none___aHQNf {
  flex: none !important;
}

.HuddleVisitCard-module__flex-column___rmsb4 {
  display: flex;
  flex-direction: column !important;
}

.HuddleVisitCard-module__flex-row___NieEA {
  display: flex;
  flex-direction: row !important;
}

.HuddleVisitCard-module__vertically-centered___UZr3W {
  display: flex;
  align-items: center !important;
}

.HuddleVisitCard-module__horizontally-centered___VyyDj {
  display: flex;
  justify-content: center !important;
}

.HuddleVisitCard-module__horizontally-end___FJPDq {
  display: flex;
  justify-content: end !important;
}

.HuddleVisitCard-module__vertically-start___Pni68 {
  display: flex;
  align-items: start !important;
}

.HuddleVisitCard-module__space-between___T1hqy {
  display: flex;
  justify-content: space-between !important;
}

.HuddleVisitCard-module__flex-wrap___UlQQP {
  flex-wrap: wrap !important;
}

.HuddleVisitCard-module__height-100___o6MEe {
  height: 100%;
}

.HuddleVisitCard-module__width-50___CWGLq {
  width: 50% !important;
}

.HuddleVisitCard-module__width-100___rZ0dv {
  width: 100%;
}

.HuddleVisitCard-module__cursor-pointer___wn086 {
  cursor: pointer;
}

.HuddleVisitCard-module__cursor-not-allowed___h7SGd {
  cursor: not-allowed !important;
}

.HuddleVisitCard-module__absolute-centered___EvZiy {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.HuddleVisitCard-module__absolute___G6bBT {
  position: absolute;
}

.HuddleVisitCard-module__relative___acoEB {
  position: relative;
}

.HuddleVisitCard-module__fixed___LWhpR {
  position: fixed;
}

.HuddleVisitCard-module__visible___xSpFz {
  opacity: 1;
}

.HuddleVisitCard-module__invisible___no4Nr {
  opacity: 0;
}

.HuddleVisitCard-module__col-90___BrSNO {
  width: 90% !important;
}

.HuddleVisitCard-module__col-auto___PtdqU {
  width: auto !important;
}

.HuddleVisitCard-module__medical-tabs___ZpV1C {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.HuddleVisitCard-module__medical-table-new___Gh3vM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.HuddleVisitCard-module__medical-table-new___Gh3vM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.HuddleVisitCard-module__medical-table-new___Gh3vM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.HuddleVisitCard-module__medical-table-new___Gh3vM::-webkit-scrollbar-track {
  display: none;
}
.HuddleVisitCard-module__medical-table-new___Gh3vM.HuddleVisitCard-module__no-pagination___ubSMX {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.HuddleVisitCard-module__medical-table-new___Gh3vM.HuddleVisitCard-module__no-pagination___ubSMX:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.HuddleVisitCard-module__medical-table-new___Gh3vM.HuddleVisitCard-module__no-pagination___ubSMX::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.HuddleVisitCard-module__medical-table-new___Gh3vM.HuddleVisitCard-module__no-pagination___ubSMX::-webkit-scrollbar-track {
  display: none;
}

.HuddleVisitCard-module__medical-table-empty___YtHtq {
  padding: 14px 40px !important;
}

.HuddleVisitCard-module__icon-btn___xwob8 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.HuddleVisitCard-module__search-icon___PXCPJ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.HuddleVisitCard-module__disable-select___mCZlv {
  user-select: none;
}

.HuddleVisitCard-module__break-word___SCuLz {
  word-break: break-word;
}

.HuddleVisitCard-module__popup-clear-btn___aLeUB {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.HuddleVisitCard-module__scroll-m-b-20___WYgIY {
  scroll-margin-bottom: 20px;
}

.HuddleVisitCard-module__row___ewdpN {
  display: grid;
  grid-template-columns: 172px minmax(0, 1fr);
  align-items: stretch;
  gap: 12px;
}

.HuddleVisitCard-module__card___ajp9q {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1.5px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.HuddleVisitCard-module__card___ajp9q > * + * {
  border-top: 1px solid #e4e4e7;
}

.HuddleVisitCard-module__sectionsToggle___JJSIq {
  cursor: pointer;
}

.HuddleVisitCard-module__outLink___M5Kwf {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.HuddleVisitCard-module__outLink___M5Kwf:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.HuddleVisitCard-module__outLink___M5Kwf {
  outline: none;
}
.HuddleVisitCard-module__outLink___M5Kwf:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.HuddleVisitCard-module__outLink___M5Kwf:disabled, .HuddleVisitCard-module__outLink___M5Kwf[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}

.HuddleVisitCard-module__memberName___oG7aR {
  font-size: 15px;
  line-height: 1.5;
  font-weight: 600;
  color: #18181b;
}

.HuddleVisitCard-module__fact___L7osN {
  font-size: 14px;
  line-height: 1.4286;
  color: #3f3f46;
}

.HuddleVisitCard-module__athenaNote___Is1oy {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 14px;
  line-height: 1.4286;
  color: #52525b;
}

.HuddleVisitCard-module__athenaNoteIcon___uFZoR {
  flex-shrink: 0;
  margin-top: 2px;
  color: #a1a1aa;
}

.HuddleVisitCard-module__athenaNoteLabel___HBsat {
  color: #71717a;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/HuddleVisitCard/HuddleVisitCard.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,2CAAA;EACA,oBAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;AA8pBF;;AAxpBA;EACE,6BAAA;AA2pBF;;AAxpBA;EACE,eAAA;AA2pBF;;AAxpBA;EEgBE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AF4oBF;AE1oBE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AF4oBJ;AAlrBA;EEOE,aAAA;AF8qBF;AE5qBE;EACE,0BAAA;EACA,mBALuB;AFmrB3B;AE9oBE;EAEE,cAAA;EACA,eAAA;AF+oBJ;;AAzrBA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA4rBF;;AAzrBA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AA4rBF;;AAzrBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA4rBF;;AAzrBA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AA4rBF;;AAzrBA;EACE,cAAA;AA4rBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.row {\n  display: grid;\n  grid-template-columns: 172px minmax(0, 1fr);\n  align-items: stretch;\n  gap: 12px;\n}\n\n.card {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1.5px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n// Every direct child of the card is a full-width row; this puts a hairline\n// between each consecutive pair, matching the prototype's Checklist\n// (divide-y) pattern instead of each section owning its own border.\n.card > * + * {\n  border-top: 1px solid #e4e4e7;\n}\n\n.sectionsToggle {\n  cursor: pointer;\n}\n\n.outLink {\n  @include line-button;\n}\n\n.memberName {\n  font-size: 15px;\n  line-height: 1.5;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.fact {\n  font-size: 14px;\n  line-height: 1.4286;\n  color: #3f3f46;\n}\n\n.athenaNote {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 14px;\n  line-height: 1.4286;\n  color: #52525b;\n}\n\n.athenaNoteIcon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: #a1a1aa;\n}\n\n.athenaNoteLabel {\n  color: #71717a;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `HuddleVisitCard-module__font-s-10___gtsup`,
	"fontS12": `HuddleVisitCard-module__font-s-12___kpHFL`,
	"fontS13": `HuddleVisitCard-module__font-s-13___LvrDA`,
	"fontS14": `HuddleVisitCard-module__font-s-14___zJmru`,
	"fontS15": `HuddleVisitCard-module__font-s-15___Hk1Wl`,
	"fontS16": `HuddleVisitCard-module__font-s-16___Uu0hi`,
	"fontS18": `HuddleVisitCard-module__font-s-18___qH2Lv`,
	"fontS20": `HuddleVisitCard-module__font-s-20___YKGTc`,
	"fontS22": `HuddleVisitCard-module__font-s-22___YTvyy`,
	"fontS28": `HuddleVisitCard-module__font-s-28___y9nFW`,
	"fontW400": `HuddleVisitCard-module__font-w-400___gmRzx`,
	"fontW500": `HuddleVisitCard-module__font-w-500___RMOpB`,
	"fontW600": `HuddleVisitCard-module__font-w-600___KiRDZ`,
	"fontW700": `HuddleVisitCard-module__font-w-700___EH0KR`,
	"p5": `HuddleVisitCard-module__p-5___XGlmZ`,
	"p12": `HuddleVisitCard-module__p-12___l3mUB`,
	"p16": `HuddleVisitCard-module__p-16___qwFlh`,
	"p30": `HuddleVisitCard-module__p-30___MllfN`,
	"pB0": `HuddleVisitCard-module__p-b-0___UkGYT`,
	"pB5": `HuddleVisitCard-module__p-b-5___uibvp`,
	"pB10": `HuddleVisitCard-module__p-b-10___V11tz`,
	"pB12": `HuddleVisitCard-module__p-b-12___oqZPo`,
	"pB16": `HuddleVisitCard-module__p-b-16___bIERf`,
	"pB18": `HuddleVisitCard-module__p-b-18___ez_KI`,
	"pB20": `HuddleVisitCard-module__p-b-20___XfswE`,
	"pB25": `HuddleVisitCard-module__p-b-25___jRPSg`,
	"pB30": `HuddleVisitCard-module__p-b-30___ozrds`,
	"pB50": `HuddleVisitCard-module__p-b-50___PG4Ql`,
	"pT0": `HuddleVisitCard-module__p-t-0___CcR8B`,
	"pT12": `HuddleVisitCard-module__p-t-12___M7a_f`,
	"pT16": `HuddleVisitCard-module__p-t-16___HKVAK`,
	"pT18": `HuddleVisitCard-module__p-t-18___wntr0`,
	"pT20": `HuddleVisitCard-module__p-t-20___Wc954`,
	"pT30": `HuddleVisitCard-module__p-t-30___Qg3Qy`,
	"pT40": `HuddleVisitCard-module__p-t-40___QvkR8`,
	"pT50": `HuddleVisitCard-module__p-t-50___jV6Jg`,
	"pL20": `HuddleVisitCard-module__p-l-20___TxcYD`,
	"pL30": `HuddleVisitCard-module__p-l-30___qDaD0`,
	"pL40": `HuddleVisitCard-module__p-l-40___sZHGA`,
	"pR16": `HuddleVisitCard-module__p-r-16___ytIyM`,
	"pR20": `HuddleVisitCard-module__p-r-20___nv8Hz`,
	"pR30": `HuddleVisitCard-module__p-r-30___pXiWo`,
	"pR50": `HuddleVisitCard-module__p-r-50___CAJPx`,
	"pR60": `HuddleVisitCard-module__p-r-60___krWXE`,
	"mB1": `HuddleVisitCard-module__m-b-1___uzABy`,
	"mB2": `HuddleVisitCard-module__m-b-2___fhJDe`,
	"mB6": `HuddleVisitCard-module__m-b-6___cWvm_`,
	"mB8": `HuddleVisitCard-module__m-b-8___hctOj`,
	"mB10": `HuddleVisitCard-module__m-b-10___jNErZ`,
	"mB14": `HuddleVisitCard-module__m-b-14___ilnk7`,
	"mB16": `HuddleVisitCard-module__m-b-16___XgbCV`,
	"mB20": `HuddleVisitCard-module__m-b-20___ffHxa`,
	"mB22": `HuddleVisitCard-module__m-b-22___UJ8p4`,
	"mB24": `HuddleVisitCard-module__m-b-24___q2fR3`,
	"mB30": `HuddleVisitCard-module__m-b-30___HsCOb`,
	"mB32": `HuddleVisitCard-module__m-b-32___vYirt`,
	"mB40": `HuddleVisitCard-module__m-b-40___WdnHs`,
	"mT2": `HuddleVisitCard-module__m-t-2___oSJRl`,
	"mT3": `HuddleVisitCard-module__m-t-3___Lfqxs`,
	"mT4": `HuddleVisitCard-module__m-t-4___wC78H`,
	"mT5": `HuddleVisitCard-module__m-t-5___PbxdR`,
	"mT8": `HuddleVisitCard-module__m-t-8___SKtjL`,
	"mT10": `HuddleVisitCard-module__m-t-10___P4CO3`,
	"mT15": `HuddleVisitCard-module__m-t-15___cFPo3`,
	"mT16": `HuddleVisitCard-module__m-t-16___pVZJq`,
	"mT20": `HuddleVisitCard-module__m-t-20___ydWwW`,
	"mT22": `HuddleVisitCard-module__m-t-22___ZDNNv`,
	"mT30": `HuddleVisitCard-module__m-t-30___ZFYB_`,
	"mT32": `HuddleVisitCard-module__m-t-32___S7o3u`,
	"mLAuto": `HuddleVisitCard-module__m-l-auto___lIgGb`,
	"mL4": `HuddleVisitCard-module__m-l-4___ABWaO`,
	"mL5": `HuddleVisitCard-module__m-l-5___jiDeE`,
	"mL6": `HuddleVisitCard-module__m-l-6___mXOlL`,
	"mL8": `HuddleVisitCard-module__m-l-8___X3Gh2`,
	"mL10": `HuddleVisitCard-module__m-l-10___OG2aR`,
	"mL16": `HuddleVisitCard-module__m-l-16___jBqYw`,
	"mL20": `HuddleVisitCard-module__m-l-20___BQS4R`,
	"mL24": `HuddleVisitCard-module__m-l-24___Zyjjw`,
	"mL30": `HuddleVisitCard-module__m-l-30___cZsvS`,
	"mL35": `HuddleVisitCard-module__m-l-35___OpR6q`,
	"mL40": `HuddleVisitCard-module__m-l-40___Q2hJ2`,
	"mR8": `HuddleVisitCard-module__m-r-8___hkI8g`,
	"mR10": `HuddleVisitCard-module__m-r-10___L3nAL`,
	"mR16": `HuddleVisitCard-module__m-r-16___j72dv`,
	"mR20": `HuddleVisitCard-module__m-r-20___MO4s2`,
	"mR24": `HuddleVisitCard-module__m-r-24___wopSw`,
	"mR30": `HuddleVisitCard-module__m-r-30___zUu2f`,
	"mR40": `HuddleVisitCard-module__m-r-40___eLdkz`,
	"borderR3": `HuddleVisitCard-module__border-r-3____fFy1`,
	"borderR4": `HuddleVisitCard-module__border-r-4___Noc7T`,
	"borderR6": `HuddleVisitCard-module__border-r-6___moKU8`,
	"borderR10": `HuddleVisitCard-module__border-r-10___oQsCE`,
	"borderR12": `HuddleVisitCard-module__border-r-12___BP00Z`,
	"borderR16": `HuddleVisitCard-module__border-r-16___syWTW`,
	"borderR50": `HuddleVisitCard-module__border-r-50___baR_W`,
	"primaryBorder": `HuddleVisitCard-module__primary-border___YbSJr`,
	"primaryBorderB": `HuddleVisitCard-module__primary-border-b___eT2Iz`,
	"primaryBorderT": `HuddleVisitCard-module__primary-border-t___gQNLs`,
	"primaryBorderL": `HuddleVisitCard-module__primary-border-l___t2jgr`,
	"primaryBorderR": `HuddleVisitCard-module__primary-border-r___HaQEK`,
	"secondaryBorder": `HuddleVisitCard-module__secondary-border___gQgeV`,
	"secondaryBorderB": `HuddleVisitCard-module__secondary-border-b___MkhSQ`,
	"secondaryBorderT": `HuddleVisitCard-module__secondary-border-t___dTgZK`,
	"secondaryBorderL": `HuddleVisitCard-module__secondary-border-l___aiKLa`,
	"secondaryBorderR": `HuddleVisitCard-module__secondary-border-r___ueEiT`,
	"gap0": `HuddleVisitCard-module__gap-0___USMpO`,
	"gap2": `HuddleVisitCard-module__gap-2___JjgxK`,
	"gap4": `HuddleVisitCard-module__gap-4___OaemZ`,
	"gap5": `HuddleVisitCard-module__gap-5___BTZ8K`,
	"gap6": `HuddleVisitCard-module__gap-6___l3Nub`,
	"gap8": `HuddleVisitCard-module__gap-8___hOcI2`,
	"gap10": `HuddleVisitCard-module__gap-10___g18Pj`,
	"gap12": `HuddleVisitCard-module__gap-12___W6gfg`,
	"gap14": `HuddleVisitCard-module__gap-14___SG7LG`,
	"gap16": `HuddleVisitCard-module__gap-16___Lm22z`,
	"gap18": `HuddleVisitCard-module__gap-18___S9l2x`,
	"gap20": `HuddleVisitCard-module__gap-20___OYcL_`,
	"gap24": `HuddleVisitCard-module__gap-24___m55BP`,
	"gap26": `HuddleVisitCard-module__gap-26___ERqTT`,
	"gap30": `HuddleVisitCard-module__gap-30___ElnfE`,
	"gap32": `HuddleVisitCard-module__gap-32___WbdZp`,
	"gap40": `HuddleVisitCard-module__gap-40___uj46c`,
	"gap50": `HuddleVisitCard-module__gap-50___cSbFX`,
	"flex1": `HuddleVisitCard-module__flex-1___edB6P`,
	"flexNone": `HuddleVisitCard-module__flex-none___aHQNf`,
	"flexColumn": `HuddleVisitCard-module__flex-column___rmsb4`,
	"flexRow": `HuddleVisitCard-module__flex-row___NieEA`,
	"verticallyCentered": `HuddleVisitCard-module__vertically-centered___UZr3W`,
	"horizontallyCentered": `HuddleVisitCard-module__horizontally-centered___VyyDj`,
	"horizontallyEnd": `HuddleVisitCard-module__horizontally-end___FJPDq`,
	"verticallyStart": `HuddleVisitCard-module__vertically-start___Pni68`,
	"spaceBetween": `HuddleVisitCard-module__space-between___T1hqy`,
	"flexWrap": `HuddleVisitCard-module__flex-wrap___UlQQP`,
	"height100": `HuddleVisitCard-module__height-100___o6MEe`,
	"width50": `HuddleVisitCard-module__width-50___CWGLq`,
	"width100": `HuddleVisitCard-module__width-100___rZ0dv`,
	"cursorPointer": `HuddleVisitCard-module__cursor-pointer___wn086`,
	"cursorNotAllowed": `HuddleVisitCard-module__cursor-not-allowed___h7SGd`,
	"absoluteCentered": `HuddleVisitCard-module__absolute-centered___EvZiy`,
	"absolute": `HuddleVisitCard-module__absolute___G6bBT`,
	"relative": `HuddleVisitCard-module__relative___acoEB`,
	"fixed": `HuddleVisitCard-module__fixed___LWhpR`,
	"visible": `HuddleVisitCard-module__visible___xSpFz`,
	"invisible": `HuddleVisitCard-module__invisible___no4Nr`,
	"col90": `HuddleVisitCard-module__col-90___BrSNO`,
	"colAuto": `HuddleVisitCard-module__col-auto___PtdqU`,
	"medicalTabs": `HuddleVisitCard-module__medical-tabs___ZpV1C`,
	"medicalTableNew": `HuddleVisitCard-module__medical-table-new___Gh3vM`,
	"noPagination": `HuddleVisitCard-module__no-pagination___ubSMX`,
	"medicalTableEmpty": `HuddleVisitCard-module__medical-table-empty___YtHtq`,
	"iconBtn": `HuddleVisitCard-module__icon-btn___xwob8`,
	"searchIcon": `HuddleVisitCard-module__search-icon___PXCPJ`,
	"disableSelect": `HuddleVisitCard-module__disable-select___mCZlv`,
	"breakWord": `HuddleVisitCard-module__break-word___SCuLz`,
	"popupClearBtn": `HuddleVisitCard-module__popup-clear-btn___aLeUB`,
	"scrollMB20": `HuddleVisitCard-module__scroll-m-b-20___WYgIY`,
	"row": `HuddleVisitCard-module__row___ewdpN`,
	"card": `HuddleVisitCard-module__card___ajp9q`,
	"sectionsToggle": `HuddleVisitCard-module__sectionsToggle___JJSIq`,
	"outLink": `HuddleVisitCard-module__outLink___M5Kwf`,
	"memberName": `HuddleVisitCard-module__memberName___oG7aR`,
	"fact": `HuddleVisitCard-module__fact___L7osN`,
	"athenaNote": `HuddleVisitCard-module__athenaNote___Is1oy`,
	"athenaNoteIcon": `HuddleVisitCard-module__athenaNoteIcon___uFZoR`,
	"athenaNoteLabel": `HuddleVisitCard-module__athenaNoteLabel___HBsat`
};
module.exports = ___CSS_LOADER_EXPORT___;
